const slug = (text: string) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[_]*catalog[_]*/g, '') // Remove word 'catalog'
    .replace(/\s+/g, '_') // Replace spaces with _
    .replace(/<br.*>/g, '') // Remove <br> tags
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/-/g, '_') // Replace - with _
    .replace(/&/g, '_and_') // Replace & with 'and'
    .replace(/__+/g, '_'); // Replace multiple _ with single _
};

export default slug;
